import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

/**
 * Wrap a route element to require a permission.
 *   <PermissionRoute permission="roles.view"><Roles /></PermissionRoute>
 * Users without the permission are redirected to a "no access" page.
 */
export default function PermissionRoute({ permission, children }) {
  const { can } = useAuth();
  return can(permission) ? children : <Navigate to="/no-access" replace />;
}
